document.querySelectorAll( ".b-hero-homepage" ).forEach( ( block ) => {

	const videoWrapper = block.querySelector( ".b-hero-homepage__video" );
	const video = block.querySelector( ".wp-block-video video, video" );
	const playButton = block.querySelector( ".b-hero-homepage__button.-play" );
	const closeButton = block.querySelector( ".b-hero-homepage__button.-close" );

	if ( !videoWrapper || !video || !playButton || !closeButton ) {

		return;

	}

	const poster = video.getAttribute( "poster" );

	if ( poster ) {

		videoWrapper.style.setProperty(
			"--hero-homepage-poster",
			`url("${poster}")`,
		);

	}

	// Start with cover image only.
	block.classList.add( "-is-paused" );
	video.controls = false;
	video.pause();

	// On click on the play button, play the video
	playButton.addEventListener( "click", playVideo );

	// On click on the close button, pause the video
	closeButton.addEventListener( "click", pauseVideo );

	// When the video ends, go back to initial state (paused)
	video.addEventListener( "ended", pauseVideo );

	/**
	 * Play the video
	 */
	function playVideo() {

		block.classList.remove( "-is-paused" );
		block.classList.add( "-is-playing" );
		video.controls = true;
		video.play();

	}

	/**
	 * Pause the video
	 */
	function pauseVideo() {

		block.classList.add( "-is-paused" );
		block.classList.remove( "-is-playing" );
		video.controls = false;
		video.pause();

	}

} );
